/**
 * Retail billing (тарифы / докупка / ЮKassa).
 * Скрыто только у B2B (безнал); sales MVP оплату картой не прячет —
 * пользователь может оформить подписку уже во время trial.
 */
import { isB2bBillingUser } from '@/utils/b2bBilling'

export function userShowsRetailBilling(source) {
  return !isB2bBillingUser(source)
}

/** Экран «trial истёк»: B2B → без самообслуживания картой; иначе → ЛК/оплата. */
export function blocksSelfServeCardBilling(source) {
  return isB2bBillingUser(source)
}

/** @deprecated use blocksSelfServeCardBilling */
export function salesMvpBlocksSelfServeBilling(source) {
  return blocksSelfServeCardBilling(source)
}
